<template>
  <b-container class="assignment-container">
    <div v-if="!error && assignmentComponent">
      <!--Start Assignment Header-->
      <h1>
        {{ assignmentComponent.title }}
        <a class="label label-outline"
           v-if="assignmentComponent.starterId"
           :href="starter_code_base_path + '/' + courseId + '/' + assignmentComponent.starterId">
          {{ assignmentComponent.starterId }}
        </a>
      </h1>
      <!--End Assignment Header-->
      <hr>
      <!--Start Assignment Body-->
      <component :is="assignmentId" />
      <!--End Assignment Body-->
    </div>

    <p v-else>{{ error }}</p>

  </b-container>
</template>

<script>
import { system } from 'settings/index'
import courses from 'components/courses/settings'

export default {
  name: 'Assignment',
  data () {
    return {
      starter_code_base_path: system.starter_code,
      courseId: null,
      assignmentId: null,
      assignmentComponent: null,
      error: null
    }
  },
  components: (() => {
    // Load all assignments from 'components/assignments'
    const context = require.context('components/assignments/', true, /\.(js|vue)$/i)
    return context.keys().reduce((obj, file) => {
      const name = file.replace(/^\.\//, '').replace(/\.(js|vue)$/, '').replace('/', '_')
      obj['assignment_' + name] = context(file).default
      return obj
    }, {})
  })(),
  mounted: function () {
    this.error = 'Assignment Not Found'

    // Find assignment template with courseId and assignmentId
    Object.keys(this.$options.components).forEach(componentName => {
      // Extract courseId and template name
      let [_, courseId, ...name] = componentName.split('_')
      // Skip if the quiz is for another class
      if (courseId !== this.$route.params['courseId']) return

      // Now try to match template name
      name = name.join('')
      // Template is considered as a match if it's name can match quizId
      // under any of the following transformations
      const possibleMatches = [
        name, // Match Camel Case
        name.toUpperCase(), // Match All Upper Case
        name.toLowerCase(), // Match All Lower Case
        name.split(/(?=[A-Z])/).join('_').toLowerCase(), // Match Snake Case with underscore
        name.split(/(?=[A-Z])/).join('-').toLowerCase() // Match Snake Case with Hyphen
      ]
      const match = possibleMatches.indexOf(this.$route.params['assignmentId'])
      // Find a match
      if (match >= 0 && possibleMatches[match] !== this.$options.name) {
        this.courseId = courseId
        this.assignmentId = componentName
        this.assignmentComponent = this.$options.components[componentName]

        // Change page header
        document.title = [this.assignmentComponent.title, courses[this.courseId]['class'], 'Self-Paced Center'].join(' | ')
        this.error = null
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/global/submodule/Assignment.vue